module.exports = __webpack_public_path__ + "static/media/border-bottom.4e762a78.png";